import React, { memo } from 'react';
import { connect } from 'react-redux';
import { projectRole, USER_ROLE_MODEL } from '@model';
import { Tooltip } from 'antd';
// import '@style/modules/analysis/analysis.scss';
import '../styles/modules/analysis/analysis.scss';
function AccessIndicator({ page, userInfo, permissions }) {
  const role = userInfo.role;
  const clientHasAccess = permissions.includes(page);

  const title = clientHasAccess
    ? 'Page access granted to client'
    : 'Page access not granted to client';
  return role !== USER_ROLE_MODEL.CLIENT ? (
    <Tooltip
      title={title}
      placement="bottomLeft"
      overlayClassName="no-arrow-tooltip"
    >
      <div
        className={`access-indicator appkiticon icon-view-fill ${
          clientHasAccess ? 'unlock' : 'lock'
        }`}
      />
    </Tooltip>
  ) : null;
}

const mapStateToProps = ({ projects, login, common }) => ({
  permissions: projects.userPermission,
  userInfo: login.userInfo || {},
  // isPwcReadOnly:
  //   common.projectCompanyInfo?.currentUserPermission ===
  //   projectRole['View-Only'],
});

export default connect(mapStateToProps)(memo(AccessIndicator));
